/* import __COLOCATED_TEMPLATE__ from './mobile-update-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();